// Shared date formatters. Use these everywhere a date or date-time is
// rendered to the user so the format is consistent (en-GB DD/MM/YYYY)
// across pages.

const DATE_OPTS = { day: '2-digit', month: '2-digit', year: 'numeric' };
const DATETIME_OPTS = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };

const toDate = (value) => {
  if (value == null || value === '') return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (value, fallback = '-') => {
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-GB', DATE_OPTS) : fallback;
};

export const formatDateTime = (value, fallback = '-') => {
  const d = toDate(value);
  return d ? d.toLocaleString('en-GB', DATETIME_OPTS) : fallback;
};
